<template>
  <div :id="$attrs['id']" :class="[$attrs['class'], gridClasses, childComponent]" @click="$emit('click', $event)">
    <div :class="{'hasFocus': hasFocus, 'hasContent': !isEmpty, 'hasError': hasError, 'hasWarning': hasWarning, 'hm-input--disabled': disabled}" class="hm-input">
      <slot />
      <div class="hm-input__label" v-html="displayLabel" />
      <div :title="helperText" class="hm-input__helper-text" v-html="helperText" />
    </div>
  </div>
</template>

<script>

import GridMixin from '@/mixins/GridMixin';
import { isNil, trim, kebabCase } from 'lodash';

export default {
  name: 'BaseHmInput',

  mixins: [GridMixin],

  props: {
    name: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    help: {
      type: String,
      required: false,
    },
    hasFocus: {
      type: Boolean,
      required: false,
    },
    isEmpty: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    hasWarning: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    helperText: function () {
      if (!isNil(this.$parent.errors.first(this.name))) {
        return this.$parent.errors.first(this.name);
      } else if (!isNil(this.$parent.errors.first('value'))) {
        return this.$parent.errors.first('value');
      } else {
        return this.$t(`input.${this.name}.help`) || this.help;
      }
    },
    displayLabel: function () {
      return this.$t(`input.${this.name}.title`) || this.label;
    },
    hasError: function () {
      return !isNil(this.$parent.errors.first('value')) || !isNil(this.$parent.errors.first(this.name));
    },
    childComponent: function () {
      return `component__${kebabCase(this.$parent.inputType || this.$parent.$options.name)}`;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
   @import '~styles/components/lib/HmInput';
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/BaseHmInput.vue